interface ITimerConfig
{
	Duration: number;
	EndCallback: () => void;
	ResetCallback: () => void;
}

class Timer
{
	private Config: ITimerConfig;
	private TimerId: NodeJS.Timeout | null = null;
	public Running: boolean;

	constructor(config: ITimerConfig)
	{
		this.Config = config;
	}

	private Clear = (): void =>
	{
		clearTimeout(this.TimerId);
		this.TimerId = null;
		this.Running = false;
	};

	public Start = (): void =>
	{
		if (!this.Running)
		{
			this.Running = true;

			this.TimerId = setTimeout(() =>
			{
				this.End();
			}, this.Config.Duration);
		}
	};

	public End = (): void =>
	{
		this.Config.EndCallback();
		this.Clear();
	};

	public Reset = (): void =>
	{
		this.Config.ResetCallback();
		this.Clear();
	};
}

export class TitleChanger
{
	private Delay: number;
	private Interval: NodeJS.Timeout | null = null;
	private NewTitle = "";
	private OriginalTitle = document.title;
	private Timer: Timer;

	constructor(title: string, delay = 10000, interval = 4000)
	{
		this.Delay = delay;
		this.NewTitle = title;
		this.Timer = new Timer({
			Duration: this.Delay,
			EndCallback: (): void =>
			{
				this.Interval = setInterval(() =>
				{
					if (document.title === this.OriginalTitle)
					{
						document.title = this.NewTitle;
					}
					else
					{
						document.title = this.OriginalTitle;
					}
				}, interval);
			},
			ResetCallback: (): void =>
			{
				document.title = this.OriginalTitle;
				clearInterval(this.Interval);
				this.Interval = null;
			}
		});

		document.addEventListener("visibilitychange", () =>
		{
			if (document.hidden && !this.Timer.Running)
			{
				this.Timer.Start();
			}
			else if (!document.hidden)
			{
				this.Timer.Reset();
			}
		});
	}
}